"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deCapitalize = deCapitalize;
exports.defaultDescriptor = void 0;
var defaultDescriptor = exports.defaultDescriptor = {
  writable: true,
  enumerable: true,
  configurable: false
};
function deCapitalize(s) {
  return s ? s.slice(0, 1).toLowerCase() + s.slice(1) : s;
}